import React, { useEffect, useState } from 'react'

export default function Header() {
    const [memberInfo, setMemberInfo] = useState(null)

    useEffect(() => {
        let mounted = true
        const fetchMember = async () => {
            try {
                const res = await fetch('https://api.cn/api/member/getMemberInfo/', { 
                    credentials: 'include' 
                })
                if (!res.ok) return
                const result = await res.json()

                const data = result && result.status && result.data
                console.log('Member info:', data)
                if (mounted) setMemberInfo(data)
            } catch (e) {
                console.error('Failed to fetch member info', e)
            }
        }
        fetchMember()
        return () => { mounted = false }
    }, [])

    const getDisplayName = (u) => {
        if (!u) return ''
        return u.nickname || u.name || u.username || '已登陆用户'
    }

    return (
        <header class="header">
            <div class="mod-head">
                <div class="inner">
                    <div class="bd">
                        <div class="logo">
                            <a href="https://api.cn/">
                                <img src="https://api.cn/static/www/image/public/logo.png" alt="APi云市场" width="200" height="125"/>
                            </a>
                        </div>
                        <div class="search">
                            <form action="/search/" onSubmit={(e) => { e.preventDefault(); const v = (e.target.keyword && e.target.keyword.value || '').trim(); const url = v ? `https://api.cn/search/?keyword=${encodeURIComponent(v)}` : '/search/'; window.location.href = url; }}>
                                <input class="input-text" type="text" name="keyword" value="" placeholder="搜索服务名称"/>
                                <button><img src="https://api.cn/static/www/image/public/icon-search.png" alt="搜索" width="20" height="20"/></button>
                            </form>
                        </div>
                        <div class="menu">
                            <ul>
                                <li><a href="https://api.cn/contact/">联系我们</a></li>
                                <li class="active"><a href="https://api.cn/market/">APi接口大全</a></li>
                                <li><a href="https://sp.api.cn/">商户入驻</a></li>
                            </ul>
                        </div>
                        <div class="user">
                            {
                                memberInfo ? (
                                    <div class="card">
                                        <div class="name"><a href="/user/">{getDisplayName(memberInfo)}</a></div>
                                        <div class="popup">
                                            <a href="/user/">用户中心</a>
                                            <a href="/pay/">账户充值</a>
                                            <a href="/member/password/">修改密码</a>
                                            <a href="/member/logout/" rel="nofollow">退出登录</a>
                                        </div>
                                    </div>
                                ):(
                                    <ul>
                                        <li><a href="https://api.cn/#login" rel="nofollow">用户登录</a></li>
                                        <li><a href="https://api.cn/#reg" rel="nofollow">用户注册</a></li>
                                    </ul>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}
